import { render, staticRenderFns } from "./ButtonGroup.vue?vue&type=template&id=ebb59d2a&scoped=true&"
import script from "./ButtonGroup.vue?vue&type=script&lang=js&"
export * from "./ButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb59d2a",
  null
  
)

export default component.exports